import { isNil } from 'es-toolkit';
import { Shapes } from 'lucide-react';

import { greyIconsColor } from '@savvy/deprecated-shared/theme';
import { mapIconColorToPalette } from '@savvy/deprecated-shared/theme/utils';

import type { XIconProps } from './types';
import { DEFAULT_ICON_SIZE } from './types';

export function XCategory({ color, size = DEFAULT_ICON_SIZE, style, onClick }: XIconProps) {
  let mappedColor = greyIconsColor;
  if (!isNil(color)) {
    mappedColor = mapIconColorToPalette[color] ?? color;
  }
  return (
    <Shapes
      onClick={onClick}
      style={{
        color: mappedColor,
        height: size,
        width: size,
        ...style,
      }}
    />
  );
}
